module.exports = __webpack_public_path__ + "img/180h100_s_dvumya_fortochkami_50h50_po_krayam_nizhney_chasti.17cfa363.svg";